const SET_PROJECT = (state, project) => {
  console.log('SET_PROJECT', project);
  state.project = project;
};

export default {
  SET_PROJECT,
};
